import { render, staticRenderFns } from "./popup2.vue?vue&type=template&id=6450978f&"
import script from "./popup2.vue?vue&type=script&lang=js&"
export * from "./popup2.vue?vue&type=script&lang=js&"
import style0 from "./popup2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports